import React from 'react';
import { EditButton, Toolbar } from './components';

export function EditToolbar({ ...props }) {
  return <Toolbar Save={EditButton} {...props} />;
}
